import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { loginThunk } from "../../store/slice/users-slice";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { is_loading } = useSelector((s) => s.users);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(loginThunk({ email, password }));
    if (loginThunk.fulfilled.match(result)) {
      // Decided here, not left to Home's own redirect — dispatching this
      // navigation from an async continuation raced with Home's effect-based
      // <Navigate> and could land back on "/" depending on timing.
      navigate(result.payload?.platform_admin ? "/platform-admin" : "/");
    } else {
      toast.error(result.payload || "Invalid email or password");
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-4">
      <div className="w-full max-w-sm rounded-lg border border-border bg-card p-8 shadow-sm">
        <div className="mb-6 text-center">
          <span className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-primary font-serif font-bold text-primary-foreground">
            M
          </span>
          <h1 className="font-serif text-2xl font-semibold">
            Medi<em className="not-italic text-primary">Pro</em>
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">Sign in to your clinic dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email or phone number</Label>
            <Input id="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <div className="relative">
              <Input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                tabIndex={-1}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>
          <Button type="submit" className="w-full" disabled={is_loading}>
            {is_loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>

      <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
        Powered by
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Aivexa" className="h-4 w-auto" />
      </p>
    </div>
  );
}
